export const addModalOpen = store => store.global.isModalOpen.isAddModalOpen;
export const editTransOpen = store => store.global.isModalOpen.isEditModalOpen;
export const logOutModalOpen = store =>
  store.global.isModalOpen.isLogOutModalOpen;
export const delModalOpen = store => store.global.isModalOpen.isDelModalOpen;
